import type { Source } from './ai';

function normalizeForCompare(value: string): string {
  return value.trim().toLowerCase().replace(/\s+/g, ' ');
}

export function resolveStatuteTitle(
  source: Source,
  statuteTitleById?: ReadonlyMap<string, string> | Record<string, string>,
): string {
  const fromSource = source.statuteTitle?.trim();
  if (fromSource) return fromSource;
  const fromMap =
    statuteTitleById instanceof Map
      ? statuteTitleById.get(source.statuteId)
      : statuteTitleById?.[source.statuteId];
  return fromMap?.trim() || '';
}

export function formatAuthorityChipLabel(
  source: Source,
  statuteTitleById?: ReadonlyMap<string, string> | Record<string, string>,
): { primary: string; secondary: string | null } {
  const statuteName = resolveStatuteTitle(source, statuteTitleById);
  const sectionLabel = source.label?.trim() || '';
  const sectionTitle = source.title?.trim() || '';

  let primary = sectionLabel || sectionTitle || 'Authority';
  if (statuteName) {
    primary = sectionLabel ? `${statuteName}, ${sectionLabel}` : statuteName;
  }

  const secondary =
    sectionTitle && normalizeForCompare(sectionTitle) !== normalizeForCompare(sectionLabel)
      ? sectionTitle
      : null;

  return { primary, secondary };
}
